import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/rem'
import store from './stores/store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import plugin from "./plugins/index"
Vue.use(ElementUI)
Vue.use(plugin,router)


import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

Vue.config.productionTip = false

let search = searchToMap();
if(search.token) localStorage.setItem("token",search.token)
localStorage.setItem("search",JSON.stringify(search));

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')


function searchToMap(){
  let search = location.search.slice(1);
  let map = {};
  if(search){
    let _searchs = search.split('?');
    _searchs.forEach(_s=>{
      let _array =_s.split('&');
      _array.forEach(str => {
        let _str = str.split('=');
        map[_str[0]] = _str[1];
      });
    })
  }
  return map;
}